module.exports = __webpack_public_path__ + "img/2024-02-13a_1.76a50788.jpg";